/**
 * Validation utilities
 */

/**
 * Validate room ID format
 * @param {string} roomId - Room ID to validate
 * @returns {boolean} True if valid
 */
export function isValidRoomId(roomId) {
  // UUID v4 format
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
  return uuidRegex.test(roomId)
}

/**
 * Validate email format
 * @param {string} email - Email to validate
 * @returns {boolean} True if valid
 */
export function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}

/**
 * Validate assessment score
 * @param {number} score - Score to validate (0-100)
 * @returns {boolean} True if valid
 */
export function isValidScore(score) {
  return typeof score === 'number' && score >= 0 && score <= 100
}

/**
 * Validate criteria weight
 * @param {number} weight - Weight to validate
 * @returns {boolean} True if valid
 */
export function isValidWeight(weight) {
  return typeof weight === 'number' && weight > 0 && weight <= 100
}

/**
 * Validate that total weights equal 100
 * @param {Array} criteria - Array of criteria with weights
 * @returns {boolean} True if total is 100
 */
export function areWeightsValid(criteria) {
  const total = criteria.reduce((sum, c) => sum + (c.weight || 0), 0)
  return Math.abs(total - 100) < 0.01 // Allow for floating point errors
}

/**
 * Sanitize HTML to prevent XSS
 * @param {string} str - String to sanitize
 * @returns {string} Sanitized string
 */
export function sanitizeHTML(str) {
  const div = document.createElement('div')
  div.textContent = str
  return div.innerHTML
}

/**
 * Validate media constraints
 * @param {Object} constraints - Media constraints object
 * @returns {boolean} True if valid
 */
export function areMediaConstraintsValid(constraints) {
  return (
    typeof constraints === 'object' &&
    (constraints.audio !== undefined || constraints.video !== undefined)
  )
}
